export default {
  globalCancel: 'إلغاء',
  globalSelect: 'اختر',
  globalAdd: 'إضافة',
  globalUploadPhoto: 'رفع صورة',
  globalDelete: 'حذف',
  globalSubmit: 'إرسال',
  globalNoData: 'لا توجد بيانات متاحة!',
  globalLoadMore: 'المزيد٠٠٠',
  chargeBalancePage: {
    choosePaymentCard: 'اختر البطاقة',
    title: 'شحن الرصيد',
    amount: 'المبلغ',
    charge: 'اشحن رصيدي',
    applePay: {
      updateApp: 'الرجاء تحديث التطبيق لاستخدام أبل باي',
      deviceMissingSupport: 'هذا الجهاز لا يدعم أبل باي',
      deviceMissingUpdates: 'يجب تحديث نظام الجهاز لدعم أبل باي',
      deviceMissingConfig: 'يجب إضافة بطاقة ﻷبل باي أو تغيير إعدادات النظام'
    }
  },
  chargeBalanceOptions: {
    title: 'خيارات شحن الرصيد',
    voucher: 'قسيمة أو بطاقة شحن',
    fawry: 'خدمة فوري في مصر',
    tamara: 'تمارا',
    registrationMessage: 'لإكمال تسجيلك كسائق، يجب عليك شحن محفظتك بحد أدنى {amount} {currency}'
  },
  chargeBalanceUsingFawryPage: {
    title: 'شحن الرصيد (خدمة فوري في مصر)',
    amount: 'المبلغ',
    charge: 'اشحن رصيدي',
    referenceNumber: 'الرقم المرجعي',
    pleasePay: 'يرجى دفع الفاتورة بالرقم المرجعي الظاهر أمامكم من خلال خدمه فوري'
  },
  chargeBalanceUsingVoucherPage: {
    title: 'شحن الرصيد (باستخدام قسيمة)',
    voucherCode: 'كود القسيمة',
    charge: 'اشحن رصيدي',
    successMessage: 'تم شحن الرصيد بنجاح'
  },
  paymentMethodsPage: {
    title: 'طرق الدفع',
    cardType: 'نوع البطاقه',
    cardNumber: 'رقم البطاقه',
    deletionConfirmation: {
      title: 'حذف البطاقة',
      content: 'هل أنت متأكد من حذف هذه البطاقة',
      successMessage: 'تم حذف البطاقة بنجاح'
    },
    addPaymentMethod: {
      title: 'إضافة بطاقة',
      choosePaymentOption: 'اختر نوع البطاقة'
    }
  },
  ticketPage: {
    sendComment: 'إرسال',
    ticketClosed: 'تم حل المشكلة بنجاح ',
    addYourMessage: 'أدخل رسالتك هنا...',
    newCommentAddedMessage: 'تم إرسال الرسالة بنجاح'
  },
  userProfile: {
    firstName: 'الإسم الأول',
    lastName: 'الإسم الأخير',
    email: 'البريد الإلكتروني',
    phone: 'رقم الجوال',
    password: 'كلمة المرور',
    copiedMessage: 'تم نسخ النص إلى الحافظة',
    referralCode: 'كود الدعوة',
    appLinkIos: 'رابط تحميل التطبيق ايفون',
    appLinkAndroid: 'رابط تحميل التطبيق اندرويد',
    editBasicInfo: {
      title: 'تعديل بيانات المستخدم',
      message: 'تم تحديث البيانات بنجاح'
    },
    uploadProfileImage: {
      message: 'تم تحديث الصورة الشخصيه بنجاح'
    },
    changePhone: {
      title: 'تغيير رقم الجوال',
      message: 'تم تغيير رقم الجوال بنجاح',
      stepOne: {
        title: 'الخطوة الأولى',
        enterPassword: 'من فضلك أدخل كلمة السر الحالية',
        confirm: 'تأكيد'
      },
      stepTwo: {
        title: 'الخطوة الثانية',
        enterPhone: 'من فضلك أدخل رقم الجوال الجديد',
        continue: 'الاستمرار'
      },
      lastStep: {
        title: 'الخطوة الأخيرة',
        enterOtp: 'من فضلك أدخل ال 4 أرقام المرسله إلى الواتساب  ',
        resendOtp: 'إعادة إرسال الرمز',
        toResend: 'ثانية لإعادة ارسال الرمز',
        otpSent: 'تم إرسال رمز مكون من أربعة أرقام إلى الواتساب',
        confirm: 'تأكيد'
      }
    },
    changePassword: {
      title: 'تغيير كلمة المرور',
      message: 'تم تغيير كلمة المرور بنجاح',
      oldPassword: 'كلمة المرور الحالة',
      newPassword: 'كلمة المرور الجديدة',
      newPasswordConfirmation: 'تأكيد كلمة المرور الجديدة'
    }
  },
  driverAccount: {
    title: 'حسابي',
    driverProfile: 'معلومات الحساب',
    vehicleInfo: 'معلومات المركبة',
    setting: 'الإعدادات',
    help: 'المساعده'
  },
  driverVehicle: {
    category: 'الفئه',
    plate: 'اللوحه',
    manufacturer: 'المصنع',
    model: 'الموديل'
  },
  driverSettings: {
    receiveAllTrips: 'استقبال جميع فئات الرحلات',
    language: 'اللغة',
    logout: 'تسجيل خروج',
    deleteAccount: 'حذف الحساب',
    successMessage: 'تم تغيير الاعدادات بنجاح',
    deleteAccountHeader: 'نأسف لأنك تريد حذف حسابك',
    deleteAccountP1:
      'إذا كنت تواجه أي مشكلة في حسابك ٫ فيمكننا على الأرجح مساعدتك في حلها٫ من فضلك',
    deleteAccountSupport: 'قم بزياره مركز المساعده',
    deleteAccountP2: 'هل أنت متأكد من حذف الحساب الخاص بك؟ إذا تابعت سيتم حذف تفاصيل حسابك'
  },
  driverEarning: {
    title: 'الأرباح'
  },
  clientWallet: {
    title: 'المحفظة'
  },
  tickets: {
    title: 'طلبات المساعده',
    createIssue: 'الإبلاغ عن مشكلة'
  },
  helpOptions: {
    title: 'خيارات المساعده'
  },
  driverRideDetails: {
    createRideIssue: 'الإبلاغ عن مشكلة بالرحلة',
    rideInfo: 'تفاصيل الرحلة',
    fareInfo: 'تفاصيل الأجره',
    time: 'التاريخ',
    category: 'الفئه',
    startAddress: 'عنوان الاستلام',
    endAddress: 'عنوان التسليم'
  },
  clientSettings: {
    beDriver: 'سجل كقائد',
    termAndCondition: 'الشروط والأحكام',
    privacy: 'سياسة الخصوصية',
    language: 'اللغة',
    logout: 'تسجيل خروج',
    deleteAccount: 'حذف الحساب',
    successMessage: 'تم تغيير الاعدادات بنجاح',
    deleteAccountHeader: 'نأسف لأنك تريد حذف حسابك',
    deleteAccountP1:
      'إذا كنت تواجه أي مشكلة في حسابك ٫ فيمكننا على الأرجح مساعدتك في حلها٫ من فضلك',
    deleteAccountSupport: 'قم بزياره مركز المساعده',
    deleteAccountP2: 'هل أنت متأكد من حذف الحساب الخاص بك؟ إذا تابعت سيتم حذف تفاصيل حسابك'
  },
  clientPromotions: {
    enterCode: 'ادخل كود الخصم هنا',
    apply: 'تطبيق'
  },
  ClientRidesHistory: {
    createRideIssue: 'الإبلاغ عن مشكلة بالرحلة',
    title: 'سجل الرحلات',
    time: 'التاريخ',
    startAddress: 'عنوان الاستلام',
    endAddress: 'عنوان التسليم'
  },
  userLogin: {
    enterPhone: 'أدخل رقم هاتفك الجوال',
    enterPassword: 'أدخل كلمة المرور',
    forgetPassword: 'نسيت كلمة المرور',
    continue: 'إستمرار',
    otpSent: 'تم إرسال رمز مكون من أربعة أرقام إلى الواتساب',
    enterOtp: 'من فضلك أدخل ال 4 أرقام المرسله إلى الواتساب',
    resendOtp: 'إعادة إرسال الرمز',
    toResend: 'ثانية لإعادة ارسال الرمز',
    resetPassword: 'إعادة تعيين كلمة المرور',
    newPassword: 'كلمة المرور الجديدة',
    newPasswordConfirmation: 'تأكيد كلمة المرور الجديدة',
    resetPasswordMessage: 'تم إعادة تعيين كلمة المرور بنجاح'
  },
  driverRegistration: {
    fillPersonalInfo: 'أضف بياناتك الشخصية لإنهاء التسجيل',
    continue: 'إستمرار',
    firstName: 'الإسم الأول',
    lastName: 'إسم العائلة',
    email: 'البريد الإلكتروني',
    nationality: 'الجنسية',
    city: 'المدينة',
    password: 'كلمة المرور',
    passwordConfirmation: 'تأكيد كلمة المرور',
    referredBy: 'رمز التحويل (إختياري)',
    successMessage: 'تم حفظ البيانات الشخصية بنجاح',
    uploadImages: 'من فضلك ، قم برفع حميع المستندات المطلوبة',
    imageUploadedSuccessfully: 'تم رفع الصوره بنجاح',
    areYouOwner: 'هل أنت مالك السياره ؟',
    registeredSuccessfully: 'تم التسجيل بنجاح',
    thanksForRegistration: 'شكرا على اكتمال عملية التسجيل',
    weWillReview: 'حسابك الآن في مرحلة المراجعة وسوف نتواصل معك في أقرب وقت',
    refresh: 'تحديث',
    agreeCondition: 'بتسجيلك في ايجو فأنت توافق على'
  },
  clientRegistration: {
    fillPersonalInfo: 'أضف بياناتك الشخصية لإنهاء التسجيل',
    continue: 'إستمرار',
    firstName: 'الإسم الأول',
    lastName: 'إسم العائلة',
    email: 'البريد الإلكتروني',
    password: 'كلمة المرور',
    passwordConfirmation: 'تأكيد كلمة المرور',
    referredBy: 'رمز التحويل (إختياري)',
    successMessage: 'تم حفظ البيانات الشخصية بنجاح',
    agreeCondition: 'بتسجيلك في ايجو فأنت توافق على'
  },
  issue: {
    createIssue: 'الإبلاغ عن مشكلة',
    photo: 'الصورة',
    phoneNumber: 'رقم الجوال',
    fillAllFields: 'الرجاء تعبئة جميع الحقول المطلوبة',
    additionalInfo: 'معلومات اضافية',
    driverDeleteAccountTitle: 'حذف الحساب الخاص بي',
    driverDeleteAccountText:
      'إذا كنت ترغب بالتوقف عن القيادة والعمل معنا. الرجاء إخبارنا عن طريق ملء هذا النموذج و سنحرص على إلغاء بياناتك.',
    additionalInfoDeleteAccount: 'اخبرنا لماذا ؟',
    questionOtherTitle: 'لدي استفسار مختلف عن إيجو',
    questionOtherText:
      'إذا كان لديك استفسار غير مذكور في الخيارات السابقة. يرجى ملء هذا النموذج وسنكون سعداء بمساعدتك.',
    cancellationFeeMissingTitle: 'أود أن أطلب غرامة إلغاء رحلة',
    cancellationFeeMissingText:
      'إذا قام الراكب بإلغاء رحلة ولم تحصل على رسوم الإلغاء التي تعتقد أنك تستحقها. نحن على استعداد للتأكد من هذا بالنسبة لك. يرجى ملء هذا النموذج وسيتم الاتصال بك.',
    cashNotRightTitle: 'لم أستطع جمع المبلغ الصحيح من النقود',
    cashNotRightText:
      'إذا لم تستطيع أخذ المبلغ الكامل من الراكب لأي سبب من الأسباب بعد الانتهاء من الرحلة. يرجى ملء هذا النموذج وسوف نحسم الأمر بالتأكيد في هذه الحالة.',
    cashCollected: 'الاموال المحصلة من الراكب',
    policeReport: 'تقرير الشرطة',
    dateOfAccident: 'تاريخ الحادثة',
    timeOfAccident: 'وقت الحادثة',
    locationOfAccident: 'موقع الحادثة',
    inVehicle: 'هل كنت متواجد في المركبة',
    isInjured: 'هل تمت اصابتك',
    accidentPhoto: 'صورة الحادثة',
    driverAccidentTitle: 'أود الابلاغ عن حادث مروري',
    driverAccidentText:
      'في ايجو، لا شيء أكثر أهمية من سلامة الركاب والسائقين. إذا وقعت في حادث، فإن أولويتنا هي سلامتك. لذلك تأكد من أنك في أمان، حاول الاتصال بالشرطة والإسعاف إذا لزم الأمر. من فضلك لا تنسى أن تبلغنا على الفور وسوف يتم الرد عليك قريبا.',
    isDamaged: 'هل حدث ضرر لمركبتك',
    fareAdjustedTitle: 'لدي اعتراض على تحديث في الأجرة',
    fareAdjustedText:
      'أحد الأسباب الشائعة لتعديل أرباحك هو أن الراكب قد تواصل معنا واشتكى من الرحلة. اذا تم ابلاغك بانه قد تم التعديل على سعر الفاتورة الخاصة بك وتريد الاعتراض على ذلك. فيرجى التأكد من الاتصال بنا من خلال هذا النموذج. سنراجع الأجرة، وسنرد عليك قريبًا.',
    foundItemTitle: 'مساعدة العميل بالحصول على غرض مفقود',
    foundItemText:
      'إذا وجدت أحد الممتلكات المفقودة بعد إحدى رحلاتك. نحن نوصي بشدة بالاتصال بالراكب على الفور للتأكد من تلقيهم لذلك في أقرب وقت ممكن. إذا حاولت الاتصال بالراكب دون جدوى. لا تقلق سنعتني بهذا. كل ما عليك سوى التأكد من ملء هذا النموذج وسنوافيكم بالرد قريبًا.',
    foundItemTime: 'متي وجدت الغرض',
    foundItemRide: 'هل تعلم الرحلة التي فقد فيها الغرض',
    phoneShare: 'هل تريد مشاركة رقم هاتفك مع الراكب',
    itemPhoto: 'صورة الغرض',
    willBeInTouch: 'لقد تلقينا رسالتك و سنرد عليك في اسرع وقت ممكن',
    clientPaymentOtherTitle: 'لدي استفسار مختلف',
    clientPaymentOtherText:
      'إذا كان لديك استفسار آخر عن الدفع ولم يتم تغطيته في الخيارات السابقة. يرجى الاتصال بنا عن طريق ملء هذا النموذج وسنكون سعداء بمساعدتك.',
    yourInquiry: 'استفسارك ؟',
    duplicateChargeTitle: 'لقد تم اقتطاع المبلغ مرتين لنفس الرحلة',
    duplicateChargeText:
      'إذا تمت محاسبتك مرتين على نفس الرحلة أو اكتشفت أي رسوم أخرى غير صحيحة ، فأخبرنا في أقرب وقت ممكن. املأ هذا النموذج وسنتصل بك قريبًا.',
    amount: 'المبلغ',
    firstCharge: 'تاريخ المحاسبة الاولي',
    secondCharge: 'تاريخ المحاسبة الثانية',
    thirdCharge: 'تاريخ المحاسبة الثالثة',
    cancellationFeeOption1: 'لم استطع التواصل مع السائق',
    cancellationFeeOption2: 'نقطة الالتقاء كانت غير صحيحة',
    cancellationFeeOption3: 'السائق الغي الرحلة',
    cancellationFeeOption4: 'الوقت المتوقع كان طويلا جدا',
    cancellationFeeOption5: 'الوقت المتوقع كان قصيرا جدا',
    cancellationFeeOption6: 'طلب مني السائق الغاء الرحلة',
    cancellationFeeOption7: 'سبب اخر',
    other: 'سبب اخر',
    chooseOneOfOptions: 'اختر احد هذه الخيارات',
    clientCancellationFeeTitle: 'لدي اعتراض على رسوم الإلغاء',
    clientCancellationFeeText:
      'إذا قمت بإلغاء رحلة وتم تغريمك برسوم إلغاء تعتقد أنها من المفترض أن لاتنسب إليك. نحن على استعداد للتحقق من صحتها لك. يرجى ملء هذا النموذج وسيتم الاتصال بك.',
    dangerousDriverTitle: 'لقد جعلني السائق أشعر بالتهديد',
    dangerousDriverText:
      'لا شيء أكثر أهمية من سلامتك ورضاك. إذا شعرت بالخطر من خلال قيادة السائق بسرعة، أو قد استخدم لغة مسيئة. من فضلك لا تتردد في ابلاغنا بذلك, سنأخذ الأمر على محمل الجد و سنتخذ إجراءات جدية تجاه أي سلوك غير لائق قد يعرض الركاب للخطر.',
    driverNotMatchTitle: 'معلومات السائق لا تتوافق مع بيانات البرنامج',
    driverNotMatchText:
      'قبل أن تبدأ رحلتك ، سيزودك إيجو بتفاصيل كاملة عن السائق والمركبة فقط لضمان سلامتك. إذا كان اسم السائق، أو صورة الملف الشخصي، أو السيارة، أو الموديل، أو لوحة الترخيص مختلفة عن تلك التي قمت بمطابقتها. نحن نقدر دعمك إذا أبلغت عن ذلك حتى نتمكن من اتخاذ إجراء فوري.',

    vehicleDetails: 'مصنع موديل و لون المركبة',
    driverMatch: 'هل اخبرت السائق',
    driverOtherTitle: 'لدي شكوى أخرى بخصوص السائق أو المركبة',
    driverOtherText:
      'إذا كنت ترغب في تقديم شكوى عن أي إزعاج واجهته خلال رحلتك الأخيرة ولم يذكر في القائمة السابقة. يرجى إبلاغنا وسنقوم بالإجراءات اللازمة وسوف يتم الرد عليك في أقرب وقت .',
    driverUnsafeTitle: 'لقد جعلني السائق أشعر بالتهديد',
    driverUnsafeText:
      'لا شيء أكثر أهمية من سلامتك ورضاك. إذا شعرت بالخطر من خلال قيادة السائق بسرعة، أو قد استخدم لغة مسيئة. من فضلك لا تتردد في ابلاغنا بذلك, سنأخذ الأمر على محمل الجد و سنتخذ إجراءات جدية تجاه أي سلوك غير لائق قد يعرض الركاب للخطر.',
    lostItemTitle: 'لدي غرض مفقود من خلال الرحلة',
    lostItemText:
      'إذا فقدت شيءً من ممتلكاتك في احدى رحلاتك. نوصيك بالاتصال على السائق فوراً للتأكد من ذلك. وبالإضافة الى ابلاغنا حتى نتمكن من تتبعها حتى إيصالها إليك. ويرجى ملاحظة أنه إذا فقدت هاتفك، قم بتزويدنا برقم بديل حتى نتمكن من التواصل معك بسهولة.',
    itemDescription: 'وصف الغرض',
    overChargedCashTitle: 'أود الاعتراض على المبلغ المستحق',
    overChargedCashText:
      'إذا كان مبلغ الرحلة أكثر من المتوقع أو تشك أن هناك خطأ ما في الأجرة، يرجى الأتصال بنا على الفور. و تأكد من أننا سنقوم بالإطلاع على رحلتك و سنقوم بإجراء جميع الحسابات اللازمة والاتصال بك في أقرب وقت.',
    cashExpected: 'الاجرة المتوقعة',
    cashAsked: 'الاجرة المطلوبة',
    cashPaid: 'الاجرة المدفوعة',
    poorRouteTitle: 'استغرقت الرحلة وقتا أطول من المعتاد',
    poorRouteText:
      'إذا كنت تعتقد أن الرحلة استغرقت وقتًا أطول من المتوقع نتيجة لطريق أطول أو تجاهل سائقك مسارك المفضل عن قصد. الرجاء إبلاغنا بذلك عن طريق ملء هذا النموذج ، و سننظر في تعديل رصيدك إذا كان حادثًا مقصودًا.',
    poorRouteOption1: 'الطريق كان اطول من اللازم',
    poorRouteOption2: 'السائق اخذ منعطفا خاطئا و ضل الطريق',
    poorRouteOption3: 'لم يتبع السائق ارشاداتي',
    poorRouteOption4: 'قابلنا زحام او اشغال في الطريق',
    pickupIssueTitle: 'لقد واجه السائق مشكلة في نقطة الالتقاء',
    pickupIssueText:
      'نحن نضمن لك الذهاب بأمان وسرعة لوجهتك المحددة. إذا استغرق السائق وقتًا أطول من المعتاد في الوصول إليك او لم تستطع التواصل مع السائق. يمكنك إخبارنا عن طريق ملء النموذج وسنقوم بالتواصل معك.',
    clientDeleteAccountTitle: 'أريد حذف الحساب الخاص بي',
    clientDeleteAccountText:
      'إذا اخترت حذف حساب إيجو الخاص بك ، فيمكننا مساعدتك من خلال ملئ هذا النموذج وسيتم إلغاء تنشيطه نهائيًا بعد 30 يومًا.',
    drawEarningsTitle: 'طلب سحب الأرباح',
    drawEarningsText:
      'السحب للحد الأدنى 30 ريال وللحد الأعلى 100 ريال بشرط ان يكون الرصيد المتبقي في المحفظة 100 ريال',
    drawEarningsWarning: 'المبالغ المشحونة والعروض غير مستردة',
    idNumber: 'رقم الهوية',
    stcPayPhoneNumber: 'رقم STC PAY',
    refundRequestTitle: 'طلب استرداد',
    refundRequestText:
      'إذا كنت تريد استرداد المبلغ المضاف إلى محفظتك عن طريق طلب الرحلة، قم بملء هذا النموذج وسوف تحصل عليه قريبًا.',
    refundRequestWarning: 'المبالغ المشحونة والعروض غير مستردة',
    updatePersonalDocumentsTitle: 'تحديث المستندات الشخصية',
    updatePersonalDocumentsText: 'يمكنك استخدام النموذج أدناه لتحديث معلوماتك الشخصية',
    updateVehicleDocumentsTitle: 'تحديث مستندات المركبة',
    updateVehicleDocumentsText:
      'من أجل سلامتك وسلامة الركاب يمكنك استخدام النموذج أدناه لطلب تحديث  معلومات المركبة بعد إدخال التفاصيل الصحيحة',
    idPhoto: 'صورة الهوية الوطنية',
    personalPhoto: 'صورة شخصية',
    licensePhoto: 'صورة رخصة القيادة',
    registrationPhoto: 'صورة الاستمارة',
    vehiclePhoto: 'صورة المركبة واضحة من الأمام',
    delegationPhoto: 'صورة التفويض في حال عدم ملكية المركبة',
    insurancePhoto: 'صورة التأمين'
  },
  termAndConditions: {
    termsTitle: 'الشروط والأحكام',
    termsIntroduction: `تحكم هذه الشروط والأحكام وصول واستخدام الأفراد كافة منصات إيجو الرقمية وهي شركة سعودية ذات مسؤولية محدودة تأسست في عام ٢٠١٨ باسم شركة إيجو لتقنية المعلومات ومقرها الرئيسي مدينة الرياض.
يرجى قراءة الشروط والأحكام والموافقة على ما ورد فيها للحصول على الخدمات المقدمة من إيجو.`,
    termsDefinition: 'تعريفات',
    termsPoint1Paragraph1:
      'شركة إيجو: مقدم الخدمة وحلقة الوصل بين السائق والراكب تأسست عام ٢٠١٨ باسم شركة إيجو لتقنية المعلومات ',
    termsPoint1Paragraph2: 'الموقع : https://ego-now.com',
    termsPoint1Paragraph3:
      ' التطبيق: المنصة الرقمية المعنية بتقديم الخدمات للسائق والعميل باسم Ego Driver للسائقين و Ego للعملاء',
    termsPoint1Paragraph4:
      'المحفظة: لكل من السائق والعميل محفظة مستقلة في التطبيقات يمكنهم إضافة المبالغ إليها واستخدامها في رحلاتهم حسب الطريقة المتبعة من إيجو لكل منهما',
    termsPoint1Paragraph5: 'التسعيرة: القيمة المتغيرة لمبلغ الرحلة بحسب نوع المركبة ',
    termsPoint1Paragraph6:
      'الركاب (العملاء): الأشخاص الذين يطلبون وسيلة تنقُّل أو يتلقونها، بما في ذلك الأشخاص الذين يُطلب لهم وسيلة نقل من قِبل شخص آخر',
    termsPoint1Paragraph7:
      'قائد المركبة(السائق): الأشخاص الفرديين الذين يقدمون خدمات نقل الركاب من مكان إلى آخر بمركباتهم الخاصة بعد ربطهم بالركاب عبر تطبيق إيجو.',
    termsPoint2title: 'العلاقة التعاقدية',
    termsPoint2Paragraph1:
      'يُعَدّ وصولك لمنصات إيجو الرقمية (الموقع والتطبيقات) بمثابة موافقة وإلتزام كُلي من طرفك بالشروط والأحكام دون استثناء، وفي حالة عدم الموافقة، يجب عليك التوقف فورًا عن استخدام منصات إيجو والاستفادة من خدماتها.',
    termsPoint2Paragraph2:
      'كما تحل هذه الشروط والأحكام محل أي اتفاقات سابقة أبرمت معك ويجوز لإيجو التعديل عليها في أي وقت بإرادتها المنفردة دون إشعار مسبق، لذا، يجب عليك الاطلاع عليها دوريًا من وقت لآخر. ويُعَدّ استمرارك باستخدام الخدمات بمثابة رضا وموافقة منك على الالتزام بهذه الشروط والأحكام بصيغتها المعدلة',
    termsPoint2Paragraph3:
      'أنت تقر بأنه لم يتم إنشاء أي علاقة عمل بينك وبين إيجو. أنت تقر أيضًا بعدم وجود مشروع مشترك أو شراكة بينك وبين إيجو. لا يجوز لك العمل كموظف أو وكيل أو ممثل لنا ولا ربط أي عقد نيابة عن إيجو',
    termsPoint3Title: 'الخدمات',
    termsPoint3Paragraph:
      'توفر إيجو خدمة ربط السائق بالعميل لتنسيق وجدولة خدمات النقل من خلال تطبيقات الجوال التي تملكها باسمEgo  وEgo driver بين القائد والراكب (العميل) ولا تقدم خدمات النقل وإنما يتم توفيرها من قبل القائد عند ركوب العميل وبدء الرحلة حتى انتهاءها. وتقر باستخدام الخدمات على اعتبار شخصي لا تجاري إلا إذا وافقت إيجو على خلاف ذلك باتفاق منفصل معك',
    termsPoint4Title: 'الترخيص',
    termsPoint4Paragraph:
      'بامتثالك لهذه الشروط، توافق إيجو على منحك حق الوصول إلى التطبيق والخدمات وترخيصًا قابل للإلغاء ومحدودًا وغير حصري ولا يمكن ترخيصه أو نقله لغيرك ويكون للاستخدام الشخصي دون التجاري. ويلغى الترخيص عند إلغاء استخدام الخدمات.',
    termsPoint5Title: 'القيود',
    termsPoint5Paragraph: `لا يحق لك إزالة أو نسخ أيٍ من حقوق الطبع والنشر والملكية الفكرية والعلامات التجارية المسجلة وغير المسجلة من أي جزء من الخدمات، أو نسخ الخدمات أو تعديلها أو توزيعها أو تأجيرها أو بيعها أو عرضها علانية أو بثها أو تعميمها أو استغلالها بأي طريقة أخرى باستثناء ما تسمح به إيجو صراحة. أو التلاعب بشفراتها أو عكس هندستها أو تفكيكها أو إنشاء أو التسبب في إنشاء أداة بغرض التخلص من أي جزء من الخدمات أو مسحه أو استغلال بياناته بطريقة أخرى، أو إعاقة عمل أو وظيفة أي جانب من الخدمات أو محاولة الدخول بشكل غير مصرح به للخدمات أو إتلاف أي من جوانبها أو أي من الأنظمة والشبكات المتعلقة بها.
  ستبذل إيجو جهدها لضمان عدم استخدام التطبيق إلا للسائقين والركاب الذين يتمتعون بالنزاهة والاحترام. ومع ذلك، لا نضمن أن كل مشترك يفي بالمعايير المذكورة أعلاه في جميع الأوقات.`,
    termsPoint6Title: ' الملكية',
    termsPoint6Paragraph:
      'تظل الخدمات وجميع الحقوق المتعلقة بها ملكية خاصة بشركة ايجو. ولا تمنحك هذه الشروط ولا استخدامك للخدمات أي حقوق في الخدمات أو فيما يتعلق بها بخلاف الترخيص المحدود الممنوح أعلاه ولا استخدام أو الإشارة بأي طريقة إلى أسماء الشركات أو الشعارات أو أسماء المنتجات والخدمات أو العلامات التجارية أو علامات الخدمة الخاصة بشركة ايجو',
    termsPoint7Title: 'مراقبة الآداء',
    termsPoint7Paragraph:
      'قد تتم مراقبة اداءك والتزامك بالتعليمات وسلوك وآداب العمل من وقت لآخر من خلال موظفي شركة إيجو او بواسطة طرف ثالث تعاقدت معه شركة إيجو وتقر بموافقتك التامة أننا قد نجمع صور ومستندات خلال المراقبة وقد نقوم بتقييد وصولك واستخدامك لمنصات إيجو وإيقاف حسابك نتيجة لأي مراجعة.',
    termsPoint8Title: ' البريد والرسائل النصية',
    termsPoint8Paragraph:
      'بمجرد إنشاء الحساب، فأنت توافق على أن إيجو قد ترسل إليك بريد ورسائل نصية كجزء من سياق الأعمال الطبيعي لاستخدامك للخدمات. ',
    termsPoint9Title: ' الرموز الترويجية',
    termsPoint9Paragraph: `تطبق سياسة العروض والرموز على جميع المستخدمين القائد والراكب، ويجوز لإيجو إنشاء رموزًا ترويجية وعروض لكلاهما. وتخضع لأي شروط إضافية يتم وضعها على أساس كل رمز ترويجي وعرض. تنتهي صلاحية الرمز الترويجي أو العرض عند تطبيقها في حسابك. ويمكن أن تنتهي قبل ذلك. وبإمكانك تطبيق رمز ترويجي واحد فقط لكل رحلة ولا يمكن نقله إلى الرحلة / الرحلة التالية. ويطبّق العرض مرة واحدة أثناء مدة صلاحيته، عند تطبيق عرض من إيجو على سبيل المثال أن تشحن المحفظة بمبلغ معين تحدده إيجو، ثم تحصل على رصيد إضافي تحدده إيجو، يُعدّ هذاالمبلغ الإضافي رصيد في محفظتك (القائد أو الراكب)ويمكنك استخدامه في الرحلات دون طلب تحويله نقدًا لحسابك البنكي. لا يتم تحويل مبالغ  للحساب البنكي للقائد عداالارباح على الرحلات
  ويجوز لإيجو إلغاء أي رمز ترويجي وعرض في أي وقت ولأي سبب دون تحملها أدنى مسؤولية. وهذا يشمل، على سبيل المثال لا الحصر، استخدام الرموز بطريقة غير قانونية أو احتيالية، كأن يتم إصدارها عن طريق الخطأ أو منتهية الصلاحية.
  `,
    termsPoint10Title: ' استخدام الخدمات',
    termsPoint10Paragraph: `يجب إنشاء حساب شخصي من خلال التسجيل في التطبيق لتستفيد من خدمات إيجو. ويجب أن يكون عمرك ١٨ ثمانية عشر سنة على الأقل ومركبة باسمك أو مفوض بها ورقم اللوحة بالإضافة إلى البيانات الشخصية الاسم والعنوان والعمر ورقم الهاتف المحمول وصورة الهوية الوطنية وطريقة دفع صحيحة وتمتلك جميع التراخيص اللازمة والسارية مثل رخصة السيارة والاستمارة والتأمين على المركبة وكافة المتطلبات التي تفرضها أو قد تفرضها إيجو لاستكمال التسجيل.
ويجب أن يكون عمر العميل كذلك ١٨ ثمانية عشر سنة على الأقل بالإضافة إلى البيانات الشخصية الاسم والعنوان والعمر ورقم هاتف الجوال وطريقة دفع صحيحة واحدة على الأقل.
أنت توافق على الاحتفاظ بمعلومات دقيقة وكاملة وحديثة في حسابك، وقد يؤدي عدم حفاظك على معلومات صحيحة ودقيقة وحديثة في حسابك، إلى عدم قدرتك على الوصول إلى الخدمات أو استخدامك لها. وتتحمل أنت مسؤولية جميع الأنشطة التي تجرى باسم حسابك.
وتوافق على الحفاظ على أمان وسرية اسم المستخدم وكلمة المرور الخاصين بحسابك في جميع الأوقات. ويجوز لك امتلاك حساب واحد فقط ما لم تسمح إيجو بخلاف ذلك.`,
    termsPoint10Paragraph2:
      ' توافق من جانبك على عدم تقديم أي محتوى مستخدم تشهيري أو افترائي أو مخل بالاداب العامة أو غير قانوني أو عدواني ، وذلك على النحو الذي تحدده ايجو وفق تقديرها المطلق، سواءً كانت هذه المادة محمية بموجب القانون أم لا. ويجوز لشركة ايجو مراجعة محتوى المستخدم و مراقبته وإزالته وفق تقديرها المطلق في أي وقت ولأي سبب كان دون إخطارك بذلك. و يلتزم المستخدم (السائق والراكب) بالحفاظ على سرية حساباتهم ومعلوماتهم وتفاصيل الرحلات والفواتير وعدم عرضها في منصات التواصل الاجتماعي ومخالفتهم لذلك يعرضهم للمساءلة القانونية. يتم الإفصاح عن السابق في حالة طلبها من الجهات الرسمية المختصة فقط. وما عدا ذلك فإنها سرية بين المستخدم وشركة إيجو.',
    termsPoint11Title: ' مشاركة الحساب',
    termsPoint11Paragraph: `لا يُسمح بمشاركة الحساب إلا بموافقة صريحة من إيجو
وعليك التسجيل والحفاظ على تفعيل حسابك دائماً. يجب أن لا تسمح لشخص آخر باستخدام حسابك، أو تشارك بياناتك الشخصية مع الاخرين، بما في ذلك اسم المستخدم، أو كلمة المرور، يجب أن يكون الحساب البنكي المرتبط بحسابك باسمك أيضاً.`,
    termsPoint12Title: ' حظر الأسلحة النارية',
    termsPoint12Paragraph:
      'يُحظر على الركاب ومرافقيهم بالإضافة إلى الشركاء السائقين، حمل أسلحة نارية من أي نوع عند استخدام تطبيق إيجو‫.‬',
    termsPoint13Title: ' مقاعد السيارة',
    termsPoint13Point1Paragraph:
      'يجب على القائد والراكب الامتثال للأنظمة المعمول بها عند اصطحاب الرُّضّع والأطفال الصغار. عند إجراء رحلة باصطحاب الأطفال الصغار، تقع على الراكب مسؤولية توفير مقعد مناسب للأطفال.',
    termsPoint14Title: 'الدفع',
    termsPoint14Paragraph: `سيتم تحصيل رسوم كل رحلة على حدة، ما عدا الرحلات التي تخلف عن دفعها العميل فإنها رسومها ستضاف إلى الرحلة التالية لها. الرصيد المضاف في محفظة العميل (الراكب) غير مسترد ويمكن للعميل استخدامه متى شاء حتى انتهاء الرصيد أو -بناء على طلب العميل- تحويل الرصيد إلى عميل آخر يحدده طالب التحويل.
  بالنسبة للقائد، فإن الرصيد المضاف إلى المحفظة غير مسترد ويمكنك استخدامه متى شئت. يتم شحن محفظة المستخدم القائد بحد أدنى ١٠٠ مائة ريال ثم تشغيلها وتعلم أنت (القائد) أن المبلغ غير مسترد ويمكنك تشغيله بتفعيل رحلات حتى انتهاء رصيد المحفظة أو تحويل الرصيد إلى قائد آخر يحدده طالب التحويل.
  تلتزم من جانبك بتزويد إيجو وسيلة دفع فعالة وسارية واحدة على الأقل، ويحق لإيجو كما هو ملائم لها، تحصيل المبالغ المفروضة عليك بالإضافة إلى الغرامات التي تفرضها نتيجة تأخرك في السداد.
  كما ترسل إيجو لك إيصالًا مفصلًا بالرحلة إلى بريدك الالكتروني المسجل لديها فور انتهاءها.
  إذا تم رفض تحصيل رسوم مُستحقة لـ إيجو، فقد تظهر لك بطاقة «الدفع» في إيجو، سيطلب منك التطبيق اختيار طريقة دفع قبل طلب المشوار؛ ليتم تحصيل الرصيد المُستحق منها.`,
    termsPoint14Point1Title: 'تعليق بعض الرسوم',
    termsPoint14Point1Paragraph: ` عند إضافة طريقة دفع حديثة إلى حسابك في إيجو أو عدم استخدامها لعدة أيام، ستتحقق إيجو منها من خلال إصدار تعليق مؤقت لاعتماد المعاملة.
التعليقات المؤقتة لاعتماد المعاملة هي مبالغ مالية صغيرة لا يتم تحصيلها أبدًا بشكل فعلي من حسابك. ومع ذلك، قد تلاحظ إدراج أحد هذه المبالغ في حسابك كرسوم مُعلّقة.
في بداية الرحلة، قد يجري إيجو أحيانًا تعليقًا مؤقتًا لاعتماد المعاملة في طريقة الدفع التابعة لك مقابل أجرة الرحلة المدفوعة مقدمًا. سيظهر ذلك كرسوم "مُعلّقة" في طريقة الدفع في حسابك. عند اكتمال الرحلة، سيتحول هذا التعليق لاعتماد المعاملة إلى رسوم مقابل أجرة الرحلة النهائية.
في حالة إلغاء الرحلة، أو إذا كانت الأجرة الإجمالية للرحلة مختلفة عن سعر الأجرة المدفوعة مقدمًا في التطبيق، فسيتم إلغاء التعليق الأصلي لاعتماد المعاملة من طريقة الدفع التي تستخدمها خلال بضعة أيام عمل، لكن وفقًا لسياسة البنك الذي تتعامل معه.`,
    termsPoint14Point2Title: 'فرض رسوم',
    termsPoint14Point2Paragraph1:
      'قد تكون الرسوم "المُعلقة" حجزاً لتكلفة المشوار مُقدَّماً وسيتم إلغاؤها من حسابك ولن يتم فرضها عليك مُطلقاً. إننا نُصدر دُفعات حجز تكلفة المشاوير مُقدَّماً لحمايتك بصورة أفضل من حالات الاحتيال التي يمكن حدوثها نتيجة الاستخدام غير المُصرَّح به للبطاقات. قد تلاحظ حجزاً لتكلفة المشوار مُقدَّماً، إذا أضفتَ طريقة دفع جديدةً مؤخراً، أو إذا لم تستخدم تطبيق إيجو لفترة طويلة.',
    termsPoint14Point2Paragraph2:
      'من الممكن أن يكون أحد أصدقائك أو أفراد عائلتك يستخدم حسابك في إيجو.',
    termsPoint14Point2Paragraph3: 'من الممكن أن تكون ألغيتَ مشواراً مؤخراً.',
    termsPoint14Point3Title: 'أسباب تعذُّر إتمام طلب مشوار:',
    termsPoint14Point3Point1: '1- قد تكون مديناً لإيجو بمبالغ مُستحقَّة الدفع',
    termsPoint14Point3Point2: '2- حدِّث طريقة الدفع',
    termsPoint14Point3Point3: '3- قد لا تتوفر خدمات إيجو في موقعك',
    termsPoint14Point3Point4: '4- لا يتوفر أي سائقين.',
    termsPoint14Point3Point5: '5- لم يتم تأكيد البريد الإلكتروني أو رقم الجوال.',
    termsPoint14Point3Point6: '6- حدّث المعلومات الشخصية.',
    termsPoint15Title: 'المسؤولية',
    termsPoint15Paragraph1:
      'يلتزم كلا من سائق المركبة والعميل بالقوانين والأنظمة الخاصة بشركة إيجو لتقنية المعلومات ويؤدي إخلالهما بأي منها إلى إيقاع الغرامات والعقوبات التي تقررها شركة إيجو لتقنية المعلومات. تنحصر مسؤولية إيجو في مواجهة السائق والراكب بتوفير تقنية ربطهما ببعض وتوفير طرق الدفع الملائمة. لا تكون إيجو مسؤولة عن تحصيل المبالغ لصالح السائق أو الراكب إلا في حال ثبوت تخلف أحدهما عن التزامه. إيجو ليست مسؤولة عن فقدان المتعلقات الشخصية للراكب وتعويضه عنها. عدا ذلك، توفر إيجو آلية تسليم المتعلقات الشخصية من خلال ربط الراكب بالسائق لتسلمها.',
    termsPoint15Point1Title: 'مسؤولية القائد',
    termsPoint15Point1Point1:
      'أ. إبراز جميع الوثائق الخاصة به عند طلبها من مراقب الخدمة أو من يسند له نظامًا صلاحية الضبط والتفتيش',
    termsPoint15Point1Point2: 'ب. عدم تمكين غيره من قيادة السيارة الخاصة والعمل بها في النشاط.',
    termsPoint15Point1Point3:
      'ج. الاحتفاظ بمتعلقات الراكب الشخصية على حالتها والتعاون معه لتسليمها له.',
    termsPoint15Point1Point4:
      'د. عدم تدخين القائد او السماح للركاب بالتدخين داخل المركبة أثناء الرحلات القائمة.',
    termsPoint15Point1Point5:
      'ه. الالتزام بقواعد السير على الطرق بناءً على نظام المرور ولائحته التنفيذية.',
    termsPoint15Point1Point6: 'و. عدم تحميل الحقائب والأمتعة غير اليدوية في مقصورة السيارة.',
    termsPoint15Point1Point7:
      'ز. التأكد من أن السيارة نظيفة ومزودة بجميع وسائل السلامة قبل القيام بالرحلة.',
    termsPoint15Point1Point8: 'ح. عدم تحميل الركاب إلا من جهة الرصيف المخصص للمشاة على الطرق',
    termsPoint15Point1Point9:
      'ط. مساعدة الأشخاص ذوي الإعاقة عند ركوب السيارة والنزول منها قدر الإمكان.',
    termsPoint15Point1Point10:
      'ي. الاهتمام بالمظهر والنظافة الشخصية، والالتزام بارتداء الزي الوطني أو بنطال طويل وقميص، ومراعاة المحافظة على الذوق العام..',
    termsPoint15Point1Point11: 'ك. الالتزام بالآداب العامة وحسن التعامل مع الركاب.',
    termsPoint15Point1Point12: 'ل. عدم انتهاك خصوصية الركاب بأي شكل من الأشكال.',
    termsPoint15Point1Point13:
      'م. عدم التواصل مع الركاب بعد انتهاء الرحلة إطلاقًا إلا في حالة التنسيق لتسليم مفقودات.',
    termsPoint15Point1Point14: 'ن. أي التزامات أخرى تحددها إيجو.',
    termsPoint15Point1Point15:
      'وتعلم أن مخالفة المسؤوليات الخاصة بالقائد تعرضك للمساءلة وايقاع الغرامات والعقوبات حسب أنظمة إيجو الداخلية.',
    termsPoint15Point2Title: 'مسؤولية الراكب',
    termsPoint15Point2Point1: 'أ. حسن السلوك والآداب العامة.',
    termsPoint15Point2Point2: 'ب. المحافظة على نظافة مركبة القائد وعدم تلويثها.',
    termsPoint15Point2Point3: 'ج. عدم التعرض للقائد.',
    termsPoint15Point2Point4: 'د.  الالتزام بدفع مبالغ الرحلات المستحقة عليك.',
    termsPoint15Point2Point5: 'ه. التأكد من عدم نسيان أي متعلقات شخصية قبل النزول من المركبة.',
    termsPoint15Point2Point6: 'و. أي التزامات أخرى تحددها إيجو.',
    termsPoint15Point2Point7:
      'ز. الامتناع عن التدخين -بجميع أنواعه- في المركبة أثناء الرحلات القائمة.',
    termsPoint15Point2Point8:
      'وتعلم أن مخالفة المسؤوليات الخاصة بالراكب تعرضك للمساءلة وايقاع الغرامات والعقوبات حسب أنظمة إيجو الداخلية.',
    termsPoint16Title: 'التسعير',
    termsPoint16Paragraph:
      'تتغير الرسوم الأساسية الخاصة بشركة إيجو بحسب نوع المركبة المسجلة للقائد وتقسم على النحو التالي: سعر الكيلو المقطوع خلال الرحلة، سعر الدقيقة المحسوبة خلال الرحلة، سعر رسوم الطرق والبوابات إن وجدت، رسوم المطار الإضافية إن وجدت، رسوم حكومية، رسوم ضريبية، رسوم سابقة سواء على العميل أو القائد إن وجدت، رسوم تعويضية إن وجدت، رسوم وقت الذروة إن وجدت، خصومات إيجو إن وجدت، ورسوم نسبة إيجو. تحتفظ إيجو بالحق في تعديل أي شروط تسعير سارية من وقت لآخر دون تقديم أي إشعار لك.',
    termsPoint17Title: 'الإنهاء',
    termsPoint17Paragraph1:
      'يحق لشركة إيجو إنهاء الاتفاقية فورًا وحظر وصولك إلى منصاتنا دون إشعار مسبق في حالة انتهاك أيا من شروط هذه الاتفاقية، أو أي قوانين أو لوائح معمول بها، أو التعدي والإساءة إلى سمعة إيجو وعملاءها (الركاب والسائقين) ومديريها وموظفيها عبر وسائل التواصل الاجتماعي أو التسبب في ضرر لعلامة إيجو التجارية أو سمعتها أو عملها على النحو المحدد بواسطة إيجو وفقًا لتقديرنا الخاص. يجوز لنا في الحالات المذكورة أعلاه منعك من تسجيل حساب سائق جديد وفرض الغرامات والعقوبات وفق لوائح إيجو الداخلية بما لا يتعارض مع الأنظمة المعمول بها.',
    termsPoint17Paragraph2:
      'قد نقوم أيضًا بحظر وصولك إلى تطبيقات إيجو على الفور لفترة التحقيق، إذا اشتبهنا في حدوث انتهاك للاتفاقية أو نشاط احتيالي من جانبك. ستتم إزالة حظر الوصول بمجرد أن ينفي التحقيق صحة الشكوك.',
    termsPoint17Paragraph3:
      'ويمكن للقائد والراكب إلغاء حساباتهما شريطة أن يكون رصيد الشحن صفر. إما بالقيام برحلات حتى انتهاء رصيد الشحن أو -بناء على طلبهما- تحويل الرصيد إلى حساب قائد أو عميل (راكب) آخر.',
    termsPoint17Paragraph4:
      'ولن يتمكن القائد و العميل (الراكب) من إلغاء حسابه إذا كان هناك مبالغ مطلوبة عليه لم يقم بسدادها.',
    termsPoint18Title: 'التعويض',
    termsPoint18Paragraph:
      'توافق من جانبك على تعويض وإبراء ذمة إيجو ومسؤوليها ومديريها وموظفيها عن جميع المطالبات والخسائر والمسؤوليات والنفقات (بما فيها أتعاب المحاماة) التي تنشأ عن وفيما يتعلق باستخدامك للخدمات أو انتهاكك لأي من هذه الشروط.',
    termsPoint19Title: 'المسؤولية',
    termsPoint19Paragraph:
      'تُخلي إيجو مسؤوليتها عن جميع الإقرارات والتعهدات صريحة كانت أم ضمنية أم تشريعية والتي لم يُنص عليها صراحة في هذه الشروط بما فيها الإقرارات الضمنية الخاصة بقابلية التسويق والملائمة لغرض معين وعدم المخالفة. إضافة إلى ذلك، لا تقدم إيجو أي إقرارات أو تعهدات أو ضمانات بخصوص موثوقية أو دقة مواعيد أو جودة أو ملاءمة أو توافر الخدمات أو أي منها أو بخصوص عدم انقطاع الخدمات وتعلم أن تشغيل التطبيق قد يكون مقيدًا بسبب أخطاء فنية عرضية ولا يمكننا ضمان عمل التطبيق في جميع الأوقات .ولا تضمن إيجو جودة مقدمي الخدمات الخارجيين و ملاءمتهم و سلامتهم وقدرتهم. توافق من جانبك على أن المخاطر الكاملة التي تنشأ عن استخدامك للخدمات والسلع المطلوبة فيما يتعلق بهذا الاستخدام تبقى متعلقة بك وحدك.',
    termsPoint20Title: 'النظام الحاكم',
    termsPoint20Paragraph:
      'باستثناء ما تنص عليه هذه الشروط، تخضع هذه الشروط للأنظمة داخل المملكة العربية السعودية وحدها دون غيرها وتفسر وفقًا لها، إن أي منازعات أو خلافات أو دعاوى أو خصومات تنشأ عن هذه الخدمات أو هذه الشروط أو تتعلق بها تخضع للقضاء السعودي.'
  },
  privacy: {
    privacyTitle: 'سياسة الخصوصية ',
    privacyParagraph:
      'تحكم سياسة الخصوصية الأسلوب الذي تقوم به شركة ايجو بجمع، واستخدام والحفاظ والتصريح بالمعلومات التي تم جمعها من قبل مستخدمين منصات ايجو وتطبق سياسة الخصوصية هذه في كافة منصات إيجو الرقمية',
    privacyPoint1Title: 'معلومات الهوية الشخصية:',
    privacyPoint1Paragraph:
      ' تقوم ايجو بجمع معلومات عن الهوية الشخصية من المستخدمين بطرق مختلفة، وتشمل ولا تقتصر فقط على أوقات زيارة المستخدم للمنصة، التسجيل في منصة ايجو، ملء الطلب، نموذج تحليل الاستبيان، وغير ذلك من الأنشطة، والخدمات، والميزات أو المصادر التي قد نوفرها على منصتنا. يُطلب من المستخدمين توضيح الاسم كاملا، وعنوان البريد الإلكتروني، ورقم الهاتف، وبيانات بطاقة الائتمان.',
    privacyPoint2Title: 'معلومات لا تتعلق بالهوية الشخصية',
    privacyPoint2Paragraph:
      'تقوم ايجو بجمع بعض المعلومات عن المستخدمين اينما تفاعلوا مع المنصة، وهذه المعلومات لا تتعلق بالهوية الشخصية إنما قد تتضمن نوع الهاتف الذكي والموقع ومعلومات تقنية عن أساليب اتصال المستخدم بالمنصة، مثل الشركة المستخدمة لتقديم خدمة الإنترنت وغيرها من المعلومات المشابه.',
    privacyPoint3Title: 'كيف نقوم باستخدام المعلومات التي تم جمعها',
    privacyPoint3Paragraph:
      'تقوم ايقو بجمع واستخدام المعلومات الشخصية للمستخدمين في الأغراض التالية.',
    privacyPoint3Point2Title: 'تحسين جودة خدمة العملاء',
    privacyPoint3Point2Paragraph:
      ' تساعدنا المعلومات الخاصة بك على سهولة الاستجابة لطلباتك الموجهة لخدمة العملاء واحتياجاتك للدعم بشكل أكثر فاعلية.',
    privacyPoint3Point3Title: 'إرسال رسائل إلكترونية بشكل دوري.',
    privacyPoint3Point3Paragraph:
      'عنوان البريد الإلكتروني الذي يسجله المستخدمون للتعامل مع طلبهم سوف يستخدم فقط في إرسال معلومات وتحديثات لهم تتعلق بطلبهم. وقد يُستخدم أيضاً في الاستجابة للاستفسارات وغيرها من الطلبات أو الأسئلة. وإذا قرر المستخدم الانضمام إلى قائمة مراسلاتنا، فإنه سوف يتلقى رسائل على بريده الإلكتروني تتضمن أخبار إيجو وآخر التحديثات ومعلومات تتعلق بالمنصة وتفاصيل الرحلات التي أجراها وإذا أراد المستخدم في أي وقت إلغاء تسجيل تلقي أي رسائل مستقبلية، فإننا نقدم له توجيهات مفصلة حول إلغاء التسجيل في نهاية كل رسالة على بريده الالكتروني، او يمكن للمستخدم التواصل معنا من خلال المنصة او موقعنا الالكتروني.',
    privacyPoint3Point4Title: 'لتحسين المنصة',
    privacyPoint3Point4Paragraph:
      'نسعى باستمرار لتحسين العروض المقدمة من خلال المنصة او موقعنا الالكتروني وفقاً للمعلومات والملاحظات التي نتلقاها منك.',
    privacyPoint4Title: 'كيف نقوم بحماية معلوماتك:',
    privacyPoint4Paragraph:
      'نحن نتبع الإجراءات السليمة ومعايير الأمان في جمع وحفظ والتعامل مع البيانات، وذلك لحماية تلك البيانات ضد التعامل غير المصرح به، أو التعديل، أو الإفصاح أو إتلاف بياناتك الشخصية، واسم المستخدم، وكلمة المرور، ومعلومات تخص تعاملاتك والبيانات المخزنة على منصتنا. يتم تبادل البيانات الحساسة والخاصة بين إيجو ومستخدميه من خلال قنوات اتصال مؤمنة ويتم تشفيرها وحمايتها بطرق وأساليب رقمية معتمدة.',
    privacyPoint5Title: 'مشاركة البيانات الشخصية:',
    privacyPoint5Paragraph:
      'نحن في ايجو لا نقوم ببيع، أو المتاجرة، أو تأجير بيانات الهوية الشخصية الخاصة بالمستخدمين إلى جهات أخرى، وقد نشارك المعلومات الديموغرافية العامة المجمعة والتي لا ترتبط بأي معلومات عن الهوية الشخصية الخاصة بالزائرين والمستخدمين مع شركائنا، والشركات التابعة والمعلنين وذلك للأغراض الموضحة أعلاه. وقد نستخدم طرف ثالث مقدم للخدمة ليساعدنا في تسيير أعمالنا وأيضاً في عمل المنصة أو في إدارة الأنشطة بالنيابة عنا، مثل إرسال النشرات الإخبارية أو الدراسات الاستقصائية. قد نشارك بياناتك مع هذا الطرف الثالث في حدود تلك الأغراض. وتتم مشاركة بياناتك الشخصية لدواعي أمنية بناء على طلبها من الجهات المختصة في المملكة العربية السعودية.',
    privacyPoint6Title: 'المواقع الخاصة بالطرف الثالث:',
    privacyPoint6Paragraph:
      'قد يجد المستخدمون إعلانات أو غيرها من المحتويات على منصتنا تحمل روابط لمواقع وخدمات شركائنا، أو الموردين، أو المعلنين، أو الراعين، أو مانحي التراخيص، أو غيرهم من الكيانات التي تمثل الطرف الثالث. ونحن لا نتحكم في المحتوى أو الروابط التي تظهر على تلك المواقع ولسنا مسئولين عن الممارسات التي تقوم بها المواقع المرتبطة بموقعنا. بالإضافة إلى ذلك، فإن تلك المواقع أو الخدمات، بمحتواها وروابطها قد تتغير باستمرار. وهذه المواقع والخدمات يكون لديها سياسة الخصوصية وسياسات خدمة العملاء الخاصة بها. كما أن التصفح والتفاعل على أي موقع آخر، بما في ذلك المواقع التي تحمل رابط لمنصتنا، تخضع للشروط والسياسات الخاصة بتلك المواقع',
    privacyPoint7Title: 'التغيرات التي تطرأ على سياسة الخصوصية:',
    privacyPoint7Paragraph:
      'تمتلك ايجو حرية التصرف في تحديث سياسة الخصوصية هذه في أي وقت دون اشعار مسبق. وعلى المستخدم مراجعة تاريخ التحديث أسفل هذه الصفحة، وقد نقوم بإرسال رسالة على البريد الالكتروني. لذا نحث المستخدمين على مراجعة سياسة الخصوصية بشكل متكرر للاطلاع على أي تغيرات ليكونوا على علم بما نقوم به في سبيل حماية البيانات الشخصية التي نقوم بجمعها. وان يقر ويوافق المستخدم أن استمرار وصوله للخدمات بمثابة موافقة منه على التحديثات ومسئوليته في مراجعة سياسة الخصوصية هذه بشكل دوري.',
    privacyPoint8Title: 'الموافقة على سياسة الخصوصية:',
    privacyPoint8Paragraph:
      'استخدامك لمنصات ايجو، يفيد بموافقتك على سياسة الخصوصية المتبعة لدينا والضوابط والشروط التي تحكم استخدام الموقع والتطبيقات الخاصة بنا. فإذا لم تكن موافقاً على هذه السياسة، يتوجب عليك عدم استخدام منصاتنا. وإنك تقر بأن استمرار استخدامك ووصولك لها بعد إعلان التغييرات التي تطرأ على هذه السياسة أو على ضوابط وشروط استخدام المنصة بمثابة موافقة منك على هذه التغييرات.',
    privacyPoint9Title: 'للتواصل معنا:',
    privacyPoint9Paragraph:
      'إذا كان لديك أي أسئلة بشأن سياسة الخصوصية هذه، أو الممارسات بهذا المنصة، أو تعاملاتك مع المنصة، يمكنكم التواصل معنا من خلال'
  }
}
